import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Title } from 'components/misc'
import { Input, Select } from 'components/fields'

export default class Supervisor extends Component {
  static propTypes = {
    titles: PropTypes.array,
    colorClass: PropTypes.string,
    formPrefix: PropTypes.string,
    sectionIntlKey: PropTypes.string,
    sectionTitle: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    formPrefix: 'supervisor',
    sectionIntlKey: 'formTitle.supervisors_details',
    sectionTitle: 'Supervisor Details',
    titles: []
  }

  render() {
    const {
      colorClass,
      titles,
      formPrefix,
      sectionTitle,
      sectionIntlKey,
      disabled
    } = this.props

    return (
      <div>
        <Title h5 colorClass={colorClass}>
          <FormattedMessage id={sectionIntlKey} defaultMessage={sectionTitle} />
        </Title>

        <div className="row">
          <div className="col-xs-12">
            <Select
              name={`${formPrefix}Title`}
              label="Title"
              intlKey="label.title"
              options={titles}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name={`${formPrefix}Name`}
              label="name"
              intlKey="label.name"
              disabled={disabled}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name={`${formPrefix}Email`}
              label="email"
              intlKey="label.email"
              type="email"
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    )
  }
}
